export default __webpack_public_path__ + "static/media/clients.12375814.svg";